//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SectionAgencyLegalInformationKpp",
  props: {
    kpp: {
      type: String,
      default: () => ""
    }
  }
};
